export const courseAcademyUrls = {
  platformAcademy: 'https://academy.embluemail.com/course/emblue-de-0-a-100-nivel-inicial',
  youtubeThumbnail: 'https://img.youtube.com/vi/1oRq4PoFyoM/0.jpg',
};
